import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

import HeaderComponent from './components/Header';
import Layout, { Content, Footer, Header } from 'antd/es/layout/layout';
import FooterComponent from './components/Footer';
import { styles } from './styles';
import HomeSkeleton from './components/skeletons/HomeSkeleton';

const Home = lazy(() => import('./views/Home'));
const Fixture = lazy(() => import('./views/Fixture'));
const ContactUsComponent = lazy(() => import('./components/ContactUs'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const AboutUs = lazy(() => import('./components/AboutUs'));
const Standings = lazy(() => import('./views/Standings'));
const FixtureList = lazy(() => import('./views/FixtureList'));
const AddStreamComponent = lazy(() => import('./components/addStream'));
const UpdateStreamComponent = lazy(() => import('./components/UpdateStream'));
const Blogs = lazy(() => import('./views/Blogs'));
const BlogDetail = lazy(() =>
  import('./views/Blogs/BlogDetail').then((m) => ({ default: m.BlogDetail })),
);
const NotFoundPage = lazy(() => import('./views/NotFound'));

const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#111111',
};

function RouteFallback() {
  return (
    <div style={{ padding: '16px 0', minHeight: '50vh' }}>
      <HomeSkeleton matches spanSize={20} />
    </div>
  );
}

const Router = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={styles.header}>
        <HeaderComponent></HeaderComponent>
      </Header>
      <Content style={{ background: '#222121', textAlign: 'center', flex: 1 }}>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path='/fixtures/:categoryName/:subCategoryName' element={<Home />} />
            <Route path='/blogs/:title' element={<BlogDetail />} />
            <Route path='/' element={<Home />} />
            <Route path='/fixture/:teams' element={<Fixture />} />
            <Route path='/fixture/:teams/add' element={<AddStreamComponent />} />
            <Route path='/fixture/:teams/update' element={<UpdateStreamComponent />} />
            <Route path='/leagues/standings' element={<Standings />} />
            <Route path='/fixtures/league/:leagueName' element={<FixtureList />} />
            <Route path='/fixtures/team/:teamName' element={<FixtureList />} />
            <Route path='/blogs' element={<Blogs />} />
            <Route path='/about' element={<AboutUs />} />
            <Route path='/contact-us' element={<ContactUsComponent />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='*' element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </Content>
      <Footer style={footerStyle}>
        <FooterComponent></FooterComponent>
      </Footer>
    </Layout>
  );
};

export default Router;
